module.exports = __webpack_public_path__ + "static/media/closeIcon.e09db2fa.svg";